// extracted by mini-css-extract-plugin
export default {"plain":"Select_plain__obGCZ"};